export default "__VITE_ASSET__FRbi2l6U__"